import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';

const AdminTable = () => {
    const [tables, setTables] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [filters, setFilters] = useState({ user_id: '', template_name: '' });

    const [formData, setFormData] = useState({
        template_name: '',
        mobile: '',
        header_image_url: '',
        message: '',
        footer_message: '',
        flag: 1,
        user_id: '',
        table_name: '',
        header_type: 'image',
        is_header_static: 0,
        hcolumn: '',
        wid: '',
        pid: '', 
        lang: 'en',
    });
                
    // Fetch data
    const fetchTableData = () => {
        fetch('https://botapi.emedha.in/pages/api/template_admintableadmin')
            .then(res => res.json())
            .then(data => setTables(data))
            .catch(err => console.error('Failed to load templates:', err));
    };

    useEffect(() => {
        fetchTableData();
    }, []);

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name === 'is_header_static' ? parseInt(value) : value,
        }));
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    // Filtered rows
    const filteredTables = tables.filter(table =>
        (filters.user_id === '' || String(table.user_id) === filters.user_id) &&
        (filters.template_name === '' || table.template_name.toLowerCase().includes(filters.template_name.toLowerCase()))
    );

    // Form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData();
        form.append('template_name', formData.template_name);
        form.append('mobile', formData.mobile);
        form.append('message', formData.message);
        form.append('footer_message', formData.footer_message);
        form.append('flag', formData.flag);
        form.append('user_id', formData.user_id);
        form.append('table_name', formData.table_name);
        form.append('header_type', formData.header_type);
        form.append('is_header_static', formData.is_header_static);
        form.append('hcolumn', formData.hcolumn);
        form.append('wid', formData.wid);
        form.append('pid', formData.pid);
        form.append('lang', formData.lang);
        if (formData.header_image_url && formData.header_image_url instanceof File) {
            form.append('header_image_url', formData.header_image_url);
        }
        try {
            const endpoint = editingId !== null
                ? 'https://botapi.emedha.in/pages/api/template_updateadmin'
                : 'https://botapi.emedha.in/pages/api/template_submitadmin';

            if (editingId !== null) {
                form.append('id', editingId);
            }
            const res = await fetch(endpoint, {
                method: editingId !== null ? 'PUT' : 'POST',
                body: form,
            });
            if (!res.ok) throw new Error('Submit failed');
            fetchTableData();
            setEditingId(null);
            resetForm();
        } catch (err) {
            console.error('Submit error:', err);
        }
    };

    // Reset form
    const resetForm = () => {
        setFormData({
            template_name: '',
            mobile: '',
            header_image_url: '',
            message: '',
            footer_message: '',
            flag: 1,
            user_id: '',
            table_name: '',
            header_type: 'image',
            is_header_static: 0,
            hcolumn: '',
            wid: '',
            pid: '',
            lang: 'en',
        });
    };

    // Edit row
    const handleEdit = (table) => {
        setFormData({
            template_name: table.template_name,
            mobile: table.mobile,
            header_image_url: table.header_image_url,
            message: table.message,
            footer_message: table.footer_message,
            flag: table.flag,
            user_id: table.user_id,
            table_name: table.table_name || '',
            header_type: table.header_type || 'image',
            is_header_static: table.is_header_static || 0,
            hcolumn: table.hcolumn || '',
            wid: table.wid || '',
            pid: table.pid || '',
            lang: table.lang || 'en',
        });
        setEditingId(table.id);
    };

    // Delete row
    const handleDelete = async (id) => {
        try {
            const res = await fetch(`https://botapi.emedha.in/pages/api/template_delete?id=${id}`, {
                method: 'DELETE'
            });
            if (!res.ok) throw new Error('Delete failed');
            fetchTableData();
        } catch (err) {
            console.error('Delete error:', err);
        }
    };

    return (
        <div className="container mt-4">
            <h2 className="mb-4">Admin Template Config Table</h2>

            {/* Filters */}
            <div className="row mb-4">
                <div className="col-md-6 mb-2">
                    <input type="text" className="form-control" name="user_id" placeholder="Filter by User ID" value={filters.user_id} onChange={handleFilterChange} />
                </div>
                <div className="col-md-6">
                    <input type="text" className="form-control" name="template_name" placeholder="Filter by Template Name" value={filters.template_name} onChange={handleFilterChange} />
                </div>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="row g-3 mb-4">
                <div className="col-md-4">
                    <input type="text" className="form-control" name="template_name" placeholder="Template Name" value={formData.template_name} onChange={handleInputChange} required />
                </div>
                <div className="col-md-4">
                    <input type="text" className="form-control" name="mobile" placeholder="Mobile" value={formData.mobile} onChange={handleInputChange} />
                </div>
                <div className="col-md-4">
                    <input type="file" className="form-control" name="header_image_url" accept="image/*,video/*,.pdf" onChange={(e) => setFormData(prev => ({ ...prev, header_image_url: e.target.files[0] }))} />
                </div>
                <div className="col-md-6">
                    <textarea className="form-control" name="message" placeholder="Message" value={formData.message} onChange={handleInputChange} />
                </div>
                <div className="col-md-6">
                    <textarea className="form-control" name="footer_message" placeholder="Footer Message" value={formData.footer_message} onChange={handleInputChange} />
                </div>

                <div className="col-md-4">
                    <select className="form-select" name="table_name" value={formData.table_name} onChange={handleInputChange}>
                        <option value="">Select Table</option>
                        <option value="all">Admin</option>
                        <option value="owned">User</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <select className="form-select" name="header_type" value={formData.header_type} onChange={handleInputChange}>
                        <option value="image">Image</option>
                        <option value="pdf">PDF</option>
                        <option value="video">Video</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <label className="form-label d-block">Header Static?</label>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="is_header_static" value={0} checked={formData.is_header_static === 0} onChange={handleInputChange} />
                        <label className="form-check-label">Static</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="is_header_static" value={1} checked={formData.is_header_static === 1} onChange={handleInputChange} />
                        <label className="form-check-label">Dynamic</label>
                    </div>
                </div>

                {formData.is_header_static === 1 && (
                    <div className="col-md-4">
                        <input type="text" className="form-control" name="hcolumn" placeholder="Header Column (hcolumn)" value={formData.hcolumn} onChange={handleInputChange} />
                    </div>
                )}

                <div className="col-md-2">
                    <input type="number" className="form-control" name="user_id" placeholder="User ID" value={formData.user_id} onChange={handleInputChange} required />
                </div>
                <div className="col-md-2">
                    <select className="form-select" name="flag" value={formData.flag} onChange={handleInputChange}>
                        <option value={1}>Active</option>
                        <option value={0}>Inactive</option>
                    </select>
                </div>
                <div className="col-md-2">
                    <select className="form-select" name="lang" value={formData.lang} onChange={handleInputChange}>
                        <option value="en">English</option>
                        <option value="es">Spanish</option>
                        <option value="fr">French</option>
                    </select>
                </div>

                <div className="col-12">
                    <button type="submit" className="btn btn-primary">
                        {editingId ? 'Update' : 'Create'}
                    </button>
                </div>
            </form>

            {/* Table */}
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                        <tr>
                            <th>ID</th>
                            <th>Template Name</th>
                            <th>Mobile</th>
                            <th>Header Image</th>
                            <th>Message</th>
                            <th>Footer</th>
                            <th>User ID</th>
                            <th>Flag</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTables.map(table => (
                            <tr key={table.id}>
                                <td>{table.id}</td>
                                <td>{table.template_name}</td>
                                <td>{table.mobile}</td>
                                <td>{table.header_image_url ? (<img src={table.header_image_url} alt="Header" style={{ maxWidth: '100px', maxHeight: '60px', objectFit: 'contain' }} />) : ('No image')}</td>
                                <td>{table.message}</td>
                                <td>{table.footer_message}</td>
                                <td>{table.user_id}</td>
                                <td>{table.flag === 1 ? 'Active' : 'Inactive'}</td>
                                <td>
                                    <button className="btn btn-sm btn-outline-warning me-2" onClick={() => handleEdit(table)} title="Edit"><FaEdit /></button>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(table.id)} title="Delete"><FaTrash /></button>
                                </td>
                            </tr>
                        ))}
                        {filteredTables.length === 0 && (
                            <tr>
                                <td colSpan="9" className="text-center">No data found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminTable;
